'use strict';

window.Plaintext = window.Plaintext || {};

/**
 * Usage
 *
 const ageGateFlag = new Plaintext.FlagCookie("some-cookie-name", { expiryDays: 30 });
 const ageGateHasBeenShown = !ageGateFlag.isSet();
  
 if (!ageGateHasBeenShown) {
   showAgeGate();
  
   const ageGate = document.getElementById('ageGate');
   ageGate.addEventListener('ageGateClosed', () => ageGateShownCookie.set())
 }
 
 // Want it back?  Just this:
 ageGateFlag.clear();
 */
window.Plaintext.FlagCookie = class {
  constructor(cookieName, options) {
    this.cookieName = cookieName;
    
    const defaultOptions = {
      expiryDays: null,
      expiryHours: null,
      expirySeconds: null
    };
    
    this.options = Object.assign(defaultOptions, options);
  }
  
  clear() {
    localStorage.removeItem(this.cookieName);
  }
  
  set() {
    let expirySeconds = 0;
    
    if (this.options.expiryDays !== null) {
      expirySeconds += parseInt(this.options.expiryDays) * 86400;
    }
    
    if (this.options.expiryHours !== null) {
      expirySeconds += parseInt(this.options.expiryHours) * 3600;
    }
    
    if (this.options.expirySeconds !== null) {
      expirySeconds += parseInt(this.options.expirySeconds);
    }
    
    if (expirySeconds == 0) {
      expirySeconds = 86400 * 365 * 5; // 5 years
    }
    
    const expiryTime = this.currentTstamp() + expirySeconds;
    localStorage.setItem(this.cookieName, expiryTime);
  }
  
  isSet() {
    const val = localStorage.getItem(this.cookieName);
    
    if (val === null) { return false; }
    return val >= this.currentTstamp();
  }
  
  currentTstamp() {
    return Math.floor(Date.now() / 1000);
  }
};

/**
 * Copyright 2022 Plaintext Inc.
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
